<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import 'materialize-css/dist/js/materialize.js'

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    hideChrome () {
      return Boolean(this.$route?.meta?.hideChrome)
    }
  },
  mounted() {
    M.AutoInit();
  },
}
</script>

<template>

  <Header v-if="!hideChrome" />

  <router-view />

  <Footer v-if="!hideChrome" />


</template>

<style lang="scss">
// @import '@fortawesome/fontawesome-free/css/all.css';
@import 'materialize-css/sass/materialize.scss';
@import 'material-icons/iconfont/material-icons.css';
@import 'swiper/css/bundle';


// Customize Swiper CSS
:root {
  --swiper-theme-color: #64f023;
}

html {
  overflow-x: clip;
}

body,
html {
  width: 100%;
  max-width: 100%;
}

.swiper-pagination-bullet-active,
.swiper-pagination-bullet {
  background: #64f023 !important;
}

/* Site-wide Materialbox close (see @/lib/materialbox.js) */
.obozy-materialbox-close {
  position: fixed;
  top: max(0.75rem, env(safe-area-inset-top));
  right: max(0.75rem, env(safe-area-inset-right));
  z-index: 10050;
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 50%;
  background: rgba(33, 33, 33, 0.72);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  -webkit-tap-highlight-color: transparent;
}

.obozy-materialbox-close:hover,
.obozy-materialbox-close:focus {
  background: rgba(33, 33, 33, 0.9);
  outline: none;
}

.obozy-materialbox-close .material-icons {
  font-size: 26px;
  line-height: 1;
}

.brand-logo,
.main-title {

  /* m-plus-rounded-1c-regular - latin */
  @font-face {
    font-family: 'M PLUS Rounded 1c' !important;
    font-style: normal;
    font-weight: 500 !important;
    src: url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.eot');
    /* IE9 Compat Modes */
    src: local(''),
      url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */
      url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.woff2') format('woff2'),
      /* Super Modern Browsers */
      url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.woff') format('woff'),
      /* Modern Browsers */
      url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.ttf') format('truetype'),
      /* Safari, Android, iOS */
      url('@/assets/fonts/m-plus-rounded-1c-v15-latin-regular.svg#MPLUSRounded1c') format('svg');
    /* Legacy iOS */
  }
}

/* Third-party / legacy full-width button layout */
button.is-fullwidth,
button.is-fullwidth span {
  display: block !important;
  text-align: center !important;
}

// (third-party form helpers: keep flex rules local to those components if needed)

// Full-bleed hero banners — use 100%, not 100vw (vw ignores scrollbar and causes horizontal overflow)
.index-banner {
  width: 100%;
  max-width: 100%;
}

nav ul a,
nav .brand-logo {
  color: #444;
}

p {
  line-height: 2rem;
}

.sidenav-trigger {
  color: #040707;
}

.parallax-container {
  width: 100%;
  min-height: 420px;
  line-height: 0;
  height: auto;
  color: rgba(255, 255, 255, .9);
  display: flex;
}

.parallax-container .section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

.parallax-container img {
  background-color: #388E3C;
}

// @media only screen and (max-width : 992px) {
//   .parallax-container .section {
//     position: absolute;
//     top: 40%;
//   }
//   .index-banner .section {
//     top: 10%;
//   }
// }

// @media only screen and (max-width : 600px) {
//   .parallax-container {
//     height: 440px;
//   }

//   .index-banner .section {
//     top: 0;
//   }
// }

.inline-icon {
  display: inline-flex;
  vertical-align: bottom;
  font-size: 18px !important;
}

.icon-block {
  padding: 0 15px;
}

.icon-block .material-icons {
  font-size: inherit;
}

footer.page-footer {
  margin: 0;
}

.title,
.subtitle {
  margin-top: 30px;
}

.parallax-container .title,
.parallax-container .subtitle {
  text-shadow: 1px 1px 9px rgb(46, 46, 46);
}

.justified {
  text-align: justify !important;
}
</style>